// extracted by mini-css-extract-plugin
export default {"genericCard":"oq-z","inline":"pq-z","mastercard":"qq-z","discover":"rq-z","visa":"sq-z","amex":"tq-z","active":"uq-z"};